/* LOANS */
export const GET_LOANS = 'GET_LOANS';
export const GET_LOANS_SUCCESS = 'GET_LOANS_SUCCESS';
export const GET_LOANS_FAILURE = 'GET_LOANS_FAILURE';

export const GET_60_DAY_LOANS = 'GET_60_DAY_LOANS';
export const GET_60_DAY_LOANS_SUCCESS = 'GET_60_DAY_LOANS_SUCCESS';
export const GET_60_DAY_LOANS_FAILURE = 'GET_60_DAY_LOANS_FAILURE';

export const GET_CASH_FLOW_LOANS = 'GET_CASH_FLOW_LOANS';
export const GET_CASH_FLOW_LOANS_SUCCESS = 'GET_CASH_FLOW_LOANS_SUCCESS';
export const GET_CASH_FLOW_LOANS_FAILURE = 'GET_CASH_FLOW_LOANS_FAILURE';


/* LOAN */
export const GET_LOAN = 'GET_LOAN';
export const GET_LOAN_SUCCESS = 'GET_LOAN_SUCCESS';
export const GET_LOAN_FAILURE = 'GET_LOAN_FAILURE';

/* Loan Maturity Report */
export const GET_LOAN_MATURITY_REPORT = 'GET_LOAN_MATURITY_REPORT';
export const GET_LOAN_MATURITY_REPORT_SUCCESS = 'GET_LOAN_MATURITY_REPORT_SUCCESS';
export const GET_LOAN_MATURITY_REPORT_FAILURE = 'GET_LOAN_MATURITY_REPORT_FAILURE';
